var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_1669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.993 0H0.00703125C0.003148 0 0 0.003148 0 0.00703125V23.993C0 23.9969 0.003148 24 0.00703125 24H23.993C23.9969 24 24 23.9969 24 23.993V0.00703125C24 0.003148 23.9969 0 23.993 0Z",
    fill: "#ED2224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.625L19.2188 18.375V5.625H13.875ZM4.78125 5.625V18.375L10.125 5.625H4.78125ZM9.70312 15.7969H12.1406L13.2188 18.375H15.375L11.9531 10.2656L9.70312 15.7969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_1669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdobe);
export default __webpack_public_path__ + "static/media/icon-adobe.7cb70ce990b7ecf8d4b3253ea4e7e894.svg";
export { ForwardRef as ReactComponent };